import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
import _imports_0 from '../assets/images/betrider_logo_white.png';
const _hoisted_1 = { class: "header-section" };
const _hoisted_2 = { class: "tw-w-full" };
const _hoisted_3 = { class: "overlay" };
const _hoisted_4 = { class: "md:tw-px-6 tw-px-1" };
const _hoisted_5 = { class: "row d-flex header-area" };
const _hoisted_6 = { class: "navbar navbar-expand-lg navbar-light !tw-flex-nowrap" };
const _hoisted_7 = { class: "tw-flex tw-items-center tw-gap-2" };
const _hoisted_8 = { class: "tw-flex tw-items-center" };
const _hoisted_9 = { class: "tw-text-white tw-text-center tw-text-xs" };
const _hoisted_10 = { class: "tw-text-white tw-text-base tw-font-medium" };
const _hoisted_11 = {
    key: 0,
    class: "sidebar-wrapper"
};
const _hoisted_12 = { class: "sidebar-nav" };
const _hoisted_13 = { class: "sidebar-actions" };
const _hoisted_14 = {
    id: "navbar-content",
    class: "collapse navbar-collapse justify-content-end"
};
const _hoisted_15 = { class: "header-action d-flex align-items-center max-un tw-ml-4" };
const _hoisted_16 = { class: "tw-text-white tw-text-center tw-text-xs" };
const _hoisted_17 = { class: "tw-text-white tw-text-base tw-font-medium" };
const _hoisted_18 = { class: "tw-flex tw-items-end tw-gap-2 tw-ml-4" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_HeaderNavbar = _resolveComponent("HeaderNavbar");
    const _component_router_link = _resolveComponent("router-link");
    const _component_LangPopover = _resolveComponent("LangPopover");
    const _component_ProfilePopover = _resolveComponent("ProfilePopover");
    return (_openBlock(), _createElementBlock("header", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_HeaderNavbar),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("nav", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("button", {
                                    class: "navbar-toggler collapsed !tw-pl-0 !tw-text-white",
                                    type: "button",
                                    onClick: _cache[0] || (_cache[0] =
                                        //@ts-ignore
                                        (...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
                                }, _cache[12] || (_cache[12] = [
                                    _createElementVNode("i", { class: "fas fa-bars tw-text-white" }, null, -1)
                                ])),
                                _createVNode(_component_router_link, {
                                    to: "/",
                                    class: "navbar-brand"
                                }, {
                                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                                        _createElementVNode("img", {
                                            src: _imports_0,
                                            class: "logo d-block md:tw-w-full tw-w-28",
                                            alt: "logo"
                                        }, null, -1)
                                    ])),
                                    _: 1
                                })
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(_ctx.user ? 'tw-mr-2 min-[992px]:tw-hidden' : 'tw-hidden')
                                }, [
                                    _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('balance')), 1),
                                    _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.formattedBalance), 1)
                                ], 2),
                                (!_ctx.user?.username)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "btn-login !tw-hidden max-[992px]:!tw-block max-[330px]:!tw-text-sm",
                                        "data-bs-toggle": "modal",
                                        "data-bs-target": "#loginMod",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.openPopup('login')))
                                    }, _toDisplayString(_ctx.$t('login')), 1))
                                    : _createCommentVNode("", true),
                                (!_ctx.user?.username)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        type: "button",
                                        class: "!tw-hidden max-[992px]:!tw-block btn-registration tw-ml-3",
                                        "data-bs-toggle": "modal",
                                        "data-bs-target": "#registerMod",
                                        onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.openPopup('register')))
                                    }, _toDisplayString(_ctx.$t('register')), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            (_ctx.sidebar.showSidebar)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "sidebar-overlay tw-z-[999999]",
                                    onClick: _cache[3] || (_cache[3] =
                                        //@ts-ignore
                                        (...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
                                }))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", {
                                class: _normalizeClass(["sidebar-drawer", {
                                        'sideBar-open': _ctx.sidebar.showSidebar,
                                        '': !_ctx.sidebar.showSidebar,
                                    }])
                            }, [
                                (_ctx.sidebar.showSidebar)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _createElementVNode("button", {
                                            class: "close-btn !tw-text-white",
                                            onClick: _cache[4] || (_cache[4] =
                                                //@ts-ignore
                                                (...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
                                        }, " × "),
                                        _createElementVNode("ul", _hoisted_12, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredNavLinks, (link) => {
                                                return (_openBlock(), _createElementBlock("li", {
                                                    key: link.label,
                                                    class: "sidebar-item",
                                                    onClick: _cache[5] || (_cache[5] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
                                                }, [
                                                    _createVNode(_component_router_link, {
                                                        to: link.to,
                                                        class: _normalizeClass(["sidebar-link", {
                                                                '!tw-text-[#ED115F]': _ctx.isActive(link.route),
                                                                '!tw-text-white tw-opacity-90': !_ctx.isActive(link.route),
                                                            }])
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(link.label), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["to", "class"])
                                                ]));
                                            }), 128))
                                        ]),
                                        _createElementVNode("div", _hoisted_13, [
                                            _createVNode(_component_LangPopover),
                                            (!_ctx.user?.username)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    type: "button",
                                                    class: "btn-registration",
                                                    onClick: _cache[6] || (_cache[6] =
                                                        () => {
                                                            _ctx.openPopup('register');
                                                            _ctx.toggleSidebar();
                                                        })
                                                }, _toDisplayString(_ctx.$t('register')), 1))
                                                : _createCommentVNode("", true),
                                            (!_ctx.user?.username)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 1,
                                                    type: "button",
                                                    class: "btn-login",
                                                    onClick: _cache[7] || (_cache[7] =
                                                        () => {
                                                            _ctx.openPopup('login');
                                                            _ctx.toggleSidebar();
                                                        })
                                                }, _toDisplayString(_ctx.$t('login')), 1))
                                                : _createCommentVNode("", true),
                                            (_ctx.user?.username)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 2,
                                                    type: "button",
                                                    class: "btn-registration",
                                                    onClick: _cache[8] || (_cache[8] =
                                                        () => {
                                                            _ctx.openPopup('deposit');
                                                            _ctx.toggleSidebar();
                                                        })
                                                }, _toDisplayString(_ctx.t('deposit')), 1))
                                                : _createCommentVNode("", true),
                                            (_ctx.user?.username)
                                                ? (_openBlock(), _createBlock(_component_ProfilePopover, {
                                                    key: 3,
                                                    user: _ctx.user,
                                                    logout: _ctx.logout
                                                }, null, 8, ["user", "logout"]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ], 2),
                            _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("ul", {
                                    class: _normalizeClass(["mb-2 tw-mr-auto navbar-nav mb-lg-0", _ctx.isArabic ? 'tw-gap-6' : 'tw-gap-1'])
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredNavLinks, (link) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            key: link.label,
                                            class: _normalizeClass(["tw-relative tw-flex tw-flex-col tw-justify-end", { 'active-nav-item': _ctx.isActive(link.route) }])
                                        }, [
                                            _createVNode(_component_router_link, {
                                                to: link.to,
                                                class: _normalizeClass(["nav-link tw-font-semibold tw-bg-transparent tw-px-2.5 tw-h-full tw-w-full", {
                                                        '!tw-text-[#ED115F]': _ctx.isActive(link.route),
                                                        '!tw-text-white tw-opacity-90': !_ctx.isActive(link.route),
                                                    }])
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(link.label), 1)
                                                ]),
                                                _: 2
                                            }, 1032, ["to", "class"])
                                        ], 2));
                                    }), 128))
                                ], 2),
                                _createElementVNode("div", _hoisted_15, [
                                    (!_ctx.user?.username)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            type: "button",
                                            class: "btn-login",
                                            "data-bs-toggle": "modal",
                                            "data-bs-target": "#loginMod",
                                            onClick: _cache[9] || (_cache[9] = ($event) => (_ctx.openPopup('login')))
                                        }, _toDisplayString(_ctx.$t('login')), 1))
                                        : _createCommentVNode("", true),
                                    (!_ctx.user?.username)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            type: "button",
                                            class: "btn-registration tw-ml-3",
                                            "data-bs-toggle": "modal",
                                            "data-bs-target": "#registerMod",
                                            onClick: _cache[10] || (_cache[10] = ($event) => (_ctx.openPopup('register')))
                                        }, _toDisplayString(_ctx.$t('register')), 1))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", {
                                        class: _normalizeClass(_ctx.user ? 'tw-block tw-mr-4' : 'tw-hidden')
                                    }, [
                                        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t('balance')), 1),
                                        _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.formattedBalance), 1)
                                    ], 2),
                                    (_ctx.user?.username)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 2,
                                            type: "button",
                                            class: "btn-registration tw-mr-3",
                                            "data-bs-toggle": "modal",
                                            "data-bs-target": "#registerMod",
                                            onClick: _cache[11] || (_cache[11] = ($event) => (_ctx.openPopup('deposit')))
                                        }, _toDisplayString(_ctx.t('deposit')), 1))
                                        : _createCommentVNode("", true),
                                    (_ctx.user?.username)
                                        ? (_openBlock(), _createBlock(_component_ProfilePopover, {
                                            key: 3,
                                            user: _ctx.user,
                                            logout: _ctx.logout
                                        }, null, 8, ["user", "logout"]))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_18, [
                                    _createVNode(_component_LangPopover)
                                ])
                            ])
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
